import { render, staticRenderFns } from "./toolsList.vue?vue&type=template&id=2152a32d&scoped=true&"
import script from "./toolsList.vue?vue&type=script&lang=js&"
export * from "./toolsList.vue?vue&type=script&lang=js&"
import style0 from "./toolsList.vue?vue&type=style&index=0&id=2152a32d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2152a32d",
  null
  
)

export default component.exports